import zipObject from "lodash/zipObject";

export function unzipHeadersAndRows(body) {
  let { columns = [], rows = [] } = body;
  const items = rows.map(
    (column => row => zipObject(column, row))(columns.map(c => c.name))
  );
  //console.log("unzipHeadersAndRows(body)", items);
  return items;
}

export default unzipHeadersAndRows;
